import { API_RANKINGS_PATH, getClient } from '../api';
import { Agent, ManagerRank } from '../dtos';

export async function getManagerRank(agentId: NonNullable<Agent['id']>): Promise<ManagerRank> {
  const client = await getClient();
  const { data } = await client.get(`${API_RANKINGS_PATH}/manager/${agentId}`);

  return data;
}
